export const SIDENAV_GROUP_BY = Object.freeze({
  ALPHA: "alpha",
  BETA: "beta",
  DELTA: "delta",
  GAMMA: "gamma",
  NIU: "niu",
});

export default {};
